<SidebarShell
  :logo="short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  class="sidebar-shell-wrapper p-0 m-0 "
>

  <!-- ✅ FORWARD SIDEBAR HEADER ACTIONS (X BUTTON) -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="selected_portfolio"
      sub_label="Executive View"
      :items="tilesFormatted"
      :active_id="local_active_property"
      :open="dropdownOpen"
      @toggle="toggleDropdown"
      @select="select_tile_directly"
    >
      <template #top>
        <div 
          class="border-bottom border-secondary pb-2 mb-2"
          style="cursor: pointer;"
          @click="select_global_portfolio"
        >
          <p class="text-white-50 fw-light text-xxs mb-0">Executive Aggregate View</p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <!-- MENU -->
  <template #menu>
    <div :class="collapsed ? 'px-0 mt-3' : 'px-3 mt-3'">
      <div 
        v-for="item in menuItems"
        :key="item.key"
        class="d-flex align-items-center py-2 sidebar-menu-item"
        :class="{ active: active_menu_item === item.key }"
        style="cursor: pointer;"
        @click="select_menu_item(item.key)"
      >
        <i :class="item.icon + ' me-2 '"></i>
        <p v-if="!collapsed" class="text-xs mb-0 sidebar-menu-text">{{ item.label }}</p>
      </div>
    </div>
  </template>

</SidebarShell>
